import {h} from 'preact'
import store from "../store";
import * as actions from "../actions";
import Renderer from "../canvas/renderer";
import constants from "../constants";
import {getPromoTemplates} from "../service/templateService";
import {useCallback} from "preact/hooks";
import util from '../util';
import MenuObject from '../canvas/menu-object';
import {setIsLeftMenuVisible} from "../actions";
import canvas from "../canvas";
import MobileBotNavCollapse from "./svg/MobileBotNavCollapse";
import MobileBotNavExpand from './svg/MobileBotNavExpand';
import {EllipsisOutlined} from '@ant-design/icons';

const {dispatch} = store;
const {setPromoLoading, goToSubview, goToView, deselect, setIsQRDesignMode, setIsMobileAside} = actions;

export default function AppAsideNav({hasPdfPermission, hasTemplatesPermission, isVersionPreview, view}) {
  function goTo(view, subview) {
    dispatch(setIsLeftMenuVisible(true));
    checkRemoveEmptyMenuObjects();

    Renderer.deselectAll();
    dispatch(deselect());
    dispatch(goToView(view));
    dispatch(setIsQRDesignMode(false));

    if (subview) {
      dispatch(goToSubview(subview));
    } else {
      dispatch(goToSubview(''));
    }

    if (store.getState().isMobileVersion && !store.getState().isMobileAside) {
      dispatch(setIsMobileAside(true));
    }
  }

  const goToTemplates = useCallback(() => {
    checkRemoveEmptyMenuObjects();

    Renderer.deselectAll();
    dispatch(deselect());
    dispatch(setPromoLoading(true));
    getPromoTemplates(store.getState().designSize);
    goTo('templates');

    if (store.getState().isMobileVersion && !store.getState().isMobileAside) {
      dispatch(setIsMobileAside(true));
    }
  }, []);

  function goToGraphics() {
    checkRemoveEmptyMenuObjects();

    Renderer.deselectAll();
    dispatch(deselect());
    dispatch(goToSubview('root'));
    dispatch(goToView('graphics'));
    dispatch(setIsLeftMenuVisible(true));

    if (store.getState().isMobileVersion && !store.getState().isMobileAside) {
      dispatch(setIsMobileAside(true));
    }
  }

  function checkRemoveEmptyMenuObjects() {
    if (store.getState().menuObjectItems.length === 1 && JSON.stringify(store.getState().menuObjectItems[0]) === JSON.stringify(new MenuObject.MenuItem())) {
      const $menuObjects = $('#canvas').find('.menu-object');
      util.deleteEmptyMenuObject($menuObjects);
    }
  }

  function getDefaultTextView() {
    const useMO = canvas.getDefaultTextTab() === 'mo';

    if (useMO) {
      return goTo('text-mo', 'add-new');
    } else {
      return goTo('text-plain');
    }
  }

  function toggleMobileBotNav() {
    store.dispatch(actions.setIsMobileBottomNav(!store.getState().isMobileBottomNav));
  }

  return (store.getState().isMobileVersion && !store.getState().isMobileBottomNav ?
    <div className="bot-nav-toggle expand" onClick={() => toggleMobileBotNav()}>
      <MobileBotNavExpand/>
      <div/>
    </div>
    :
    <nav className={"main-nav"}>
      {window.data.member.hasViewOnlyPermission && <div className={"view-only-blocker"}></div>}
      {store.getState().isMobileVersion && !store.getState().hasSelection && !store.getState().isViewAllPages &&
        <div className="bot-nav-toggle collapse" onClick={() => toggleMobileBotNav()}>
          <MobileBotNavCollapse/>
        </div>}
      <ul className={isVersionPreview ? 'hidden' : ''}>
        <li>
          {hasTemplatesPermission &&
            <a className={`link ${view === 'templates' ? ' active' : ''}`} onClick={goToTemplates}>
              <svg style="width: 17px; height: 23px;">
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#template-tab-icon"}/>
              </svg>
              Templates
            </a>}
        </li>
        <li>
          <a className={`link ${(view.indexOf('text-') > -1) ? ' active' : ''} text`} onClick={getDefaultTextView}>
            <svg style="width: 20px; height: 24px;">
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#text-tab-icon"}/>
            </svg>
            Text
          </a>
        </li>
        <li>
          <a className={`link ${view === 'graphics' && !store.getState().isReplaceFrameMode ? ' active' : ''}`}
             onClick={goToGraphics}>
            <svg style="width: 23px; height: 21px;">
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#graphics-tab-icon"}/>
            </svg>
            Graphics
          </a>
        </li>
        <li>
          <a className={`link qr-tab ${view === 'qr-codes' ? ' active' : ''}`} onClick={() => goTo('qr-codes')}>
            <svg style="width: 22px; height: 22px;">
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#qr-tab-icon"}/>
            </svg>
            QR Codes
          </a>
        </li>
        <li>
          <a className={`link favorites-tab ${view === 'favorites' ? ' active' : ''}`} onClick={() => goTo('favorites')}>
            <svg style="width: 26px; height: 22px;">
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#favorites-tab-icon"} />
            </svg>
            Favorites
          </a>
        </li>


        {store.getState().isMobileVersion &&
          <li className="more">
            <a className={`link`} onClick={() => goTo('pages')}>
              <EllipsisOutlined/>
            </a>
          </li>
        }
      </ul>
    </nav>)
}
